<template>
    <el-scrollbar wrap-class="adminLayoutMainScrollbar">
        <el-menu :collapse="menuExpandState"
            :default-active="$route.path"
            :router="true"
            class="qwe-menu">
            <menuItem v-for="item in currentMenuItems"
                    :menuItem = "item"
                    :key = "item.UniqueId">
            </menuItem>
        </el-menu>           
    </el-scrollbar>
</template>

<style>
    .qwe-menu{
        border-right:0px !important;
    }

    .adminLayoutMainScrollbar{
        height: 100%;
    }
    
    .el-menu-item.is-active{
        background-color: #e6f1fa !important;
    }

    .el-menu-item{
        position: relative;
    }

    .el-menu-item.is-active::before{
        position: absolute;
        left: 0;
        display: inline-block;
        content: " ";
        width: 3px;
        height: 100%;
        background-color: #0078d4;
    }

    .adminmenu-icon{
        position:absolute;
        top:5px;
        right: -10px;
    }
    .Admin-Menu{
        position:relative
    }
</style>

<script>
    import { getMenu } from "../../apis/httpHelper"
    import menuItem from "./MenuItem.vue"
    import { RoutePathBuilder } from "."
    import { qweIsEmpty } from "../../common/commonHelper"

    let menu = {
        data: function () {
            return {
                menus: [],
                allMenu:{}
            }
        },

        computed:{
            currentModule:function(){
                return this.$store.state.currentModule;
            },
            menuExpandState:function(){
                return !this.$store.state.menuExpandState;
            },
            currentMenuItems:function(){
                return this.allMenu[this.currentModule];
            }
        },

        components: {
            'menuItem': menuItem
        },

        created: function () {
            this.initMenu();
        },
        
        methods: {
            initMenu:async function () {
                let response = await getMenu();
                this.handlerModule(response.Result);
            },

            handlerModule:function(response){
                let modules = response.Modules;
                let allMenu = {};
                response.MenuItems.forEach(x=>{
                    allMenu[x.ModuleId] = x.Menus
                })

                this.allMenu = allMenu;
                
                this.$store.commit("SetModules", modules);
                this.$store.commit("SetMenuItems", allMenu);
                
                let flatAllMenus = [];

                response.MenuItems.forEach(x=>{
                    let menus = x.Menus;
                    let listMenus = [];

                    menus.forEach(element => {
                        this.treeToList(element, listMenus)
                    }); 
                    
                    listMenus = listMenus.filter(x=>x.AdminMenuType != 0);

                    listMenus.forEach(menu=> { 
                        menu.Path = RoutePathBuilder(menu);
                        menu.DisplayName = menu.LinkText;
                        menu.CurrentModule = x.ModuleId;
                    })
                    flatAllMenus = flatAllMenus.concat(listMenus);
                })
                
                this.$store.commit("SetFlatMenuItems", flatAllMenus);
                let path = this.$route.fullPath;
                let index = flatAllMenus.findIndex(x=>x.Path == path);
                if(index>-1){
                    this.$store.commit("SetCurrentModule", flatAllMenus[index].CurrentModule);
                } 
                else{
                    if(qweIsEmpty(this.$store.state.currentModule)){
                        this.$store.commit("SetCurrentModule", modules[0].ModuleId);
                    }
                }
            },

            treeToList:function(tree,list){
                list.push(tree);
                if(tree.hasOwnProperty("Items")){
                    tree.Items.forEach(element => {
                        this.treeToList(element,list)
                    });
                }
            }
        }
    }

    export default menu
</script>